module.exports = __webpack_public_path__ + "fonts/opensans-regular.ce3b96ab.woff";